import { ErrorData } from '@ddt-web/data-service';

/**
 * FactResult: result of the fact mapping as custom data point.
 * @property {any} value value extracted from fact mapping.
 * @property {ErrorData} error error from extractor if any.
 */
export class FactResult {
	constructor(public value: any, public error?: ErrorData) {}
}
